import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=9ba87ba0&"
var script = {}
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=9ba87ba0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports